import { createAsyncThunk } from '@reduxjs/toolkit';

// Modified to use caching
export const fetchTextFile = createAsyncThunk(
  'textFile/fetch',
  async (url, { getState, rejectWithValue }) => {
    const { resources } = getState();

    // Check if the file is already cached
    if (resources.textFiles[url] && resources.textFiles[url].content) {
      // If already cached, return the cached content
      return { url, content: resources.textFiles[url].content };
    }

    // Proceed to fetch if not cached
    try {
      const response = await fetch(url);
      console.log('response', response)
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.text();
      console.log('data', data);
      return { url, content: data };
    } catch (error) {
      return rejectWithValue('Failed to fetch text file.');
    }
  }
);
